"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseApp = void 0;
var firebase = require("firebase");
var chunks_1 = require("./data/chunks");
var Request_1 = require("../../utils/Request");
var Future_1 = require("../../utils/Future");
var Settings_1 = require("../Settings");
var FirebaseApp = (function () {
    function FirebaseApp() {
    }
    FirebaseApp.prototype.init = function (env) {
        var _this = this;
        var logger = console;
        logger.log('init# env:', env);
        this.env = env;
        var baseUrl = Settings_1.Settings.SERVER_CONFIG.connections.api_iam_client;
        var queryString = '?env=NO1&api_key=YWlyYWJiaWlhbQ==';
        var future = new Future_1.Future(Future_1.futureFunc);
        logger.log((0, Request_1.request)('get', baseUrl, { env: env, api_key: 'YWlyYWJiaWlhbQ==' })
            .then(function (data) {
            _this.firebase =
                firebase.apps.length === 0
                    ? firebase.initializeApp((0, chunks_1.getConfig)(JSON.parse(data.data).config))
                    : firebase.apps[0];
            _this.firebaseGoogleProvider = new firebase.auth.GoogleAuthProvider();
            _this.firebaseFacebookProvider = new firebase.auth.FacebookAuthProvider();
            future.resolve();
        })
            .catch(function (err) { return future.reject(err); }));
        return future.promise;
    };
    FirebaseApp.GET = function () {
        if (FirebaseApp.instance) {
            return FirebaseApp.instance;
        }
        FirebaseApp.instance = new FirebaseApp();
        return FirebaseApp.instance;
    };
    return FirebaseApp;
}());
exports.FirebaseApp = FirebaseApp;
//# sourceMappingURL=FirebaseApp.js.map